import { call, put, take, race, fork, flush } from 'redux-saga/effects';
import { channel } from 'redux-saga';
import { successActionFrom, errorActionFrom } from 'utils/actions';

export const httpRequestSagaMaker = (successActionFrom, errorActionFrom) => (apiMethod, ...keys) => {
  return function*(action) {
    const { type, ...values } = action; // eslint-disable-line no-unused-vars

    try {
      const result = yield call(apiMethod, ...keys.map(key => values[key]));
      yield put(successActionFrom(action, result));
    }
    catch (error) {
      const finalError = Object.assign(error, action.errorOptions);
      yield put(errorActionFrom(action, finalError));
    }
  };
};

export function optimisticUpdateMaker({
 idKey,
 localUpdateType,
 successType,
 errorType,
 remoteUpdateActionCreator,
 localUpdateActionCreator
}) {

 return function* () {

   function* queueManager(chan) {
     let lastRemoteState = null;

     while(true) { // eslint-disable-line no-constant-condition
       const remoteUpdateAction = yield take(chan);
       yield put(remoteUpdateAction);

       if(!lastRemoteState) {
         lastRemoteState = remoteUpdateAction.stateBeforeLocalUpdate;
       }

       const { errorAction, successAction } = yield race({ // eslint-disable-line no-unused-vars
         errorAction: take(errorType),
         successAction: take(successType)
       });

       if(successAction) {
         lastRemoteState = null;
       }
       else {
         yield flush(chan);

         const revertLocalUpdateAction = yield call(localUpdateActionCreator, lastRemoteState, errorAction);

         yield put(revertLocalUpdateAction);
       }
     }
   }

   const chans = {};

   while(true) { // eslint-disable-line no-constant-condition
     const localUpdateAction = yield take(localUpdateType);
     const id = localUpdateAction[idKey];

     if(localUpdateAction.stateBeforeLocalUpdate) {
       const remoteUpdateAction = yield call(remoteUpdateActionCreator, localUpdateAction);

       if(remoteUpdateAction) {
         if(!chans[id]) {
           chans[id] = yield call(channel);
           yield fork(queueManager, chans[id]);
         }

         yield put(chans[id], {
           ...remoteUpdateAction,
           stateBeforeLocalUpdate: localUpdateAction.stateBeforeLocalUpdate
         });
       }
     }
   }
 };
}

export function *socketRequestWithErrorChecks(socket, method, action, ...args) {
  const { type, ...values } = action; // eslint-disable-line no-unused-vars

  try {
    const result = yield call([socket, method], ...args);
    yield put(successActionFrom(action, result));
  }
  catch (error) {
    yield put(errorActionFrom(action, error));
  }
}

export function navigateToWebsite() {
  window.location.href = process.env.KOOTH_UNAUTH_URL;
}



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/utils/sagas.js
 **/